import angular from 'angular';
const localStorage = window.localStorage;
const DEFAULT_SHOW_DELAY = 1000;
const DEFAULT_HIDE_DELAY = 10000;
export class CallQualitySurveyService {
    constructor(activeComponents) {
        this.activeComponents = activeComponents;
        this.hideTimeout = null;
        this.showTimeout = null;
        this.showSurvey = false;
    }
    clearTimeouts() {
        if (this.hideTimeout !== null) {
            clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
        }
        if (this.showTimeout !== null) {
            clearTimeout(this.showTimeout);
            this.showTimeout = null;
        }
    }
    show() {
        this.clearTimeouts();
        this.activeComponents.chat.toggleChat(false);
        this.showSurvey = true;
    }
    hide() {
        this.clearTimeouts();
        this.showSurvey = false;
    }
    showDelayedOneIn(oneInNumber, delay = DEFAULT_SHOW_DELAY) {
        // will generate numbers from 0 to oneInNumber - 1
        let shouldBeShown = Math.floor(Math.random() * oneInNumber) === 0;
        if (localStorage?.getItem('testing-always-show-survey')) {
            shouldBeShown = true;
        }
        if (shouldBeShown) {
            this.showDelayed(delay);
        }
        else {
            this.clearTimeouts();
        }
    }
    showDelayed(delay = DEFAULT_SHOW_DELAY) {
        this.clearTimeouts();
        this.showTimeout = window.setTimeout(() => {
            this.show();
        }, delay);
    }
    hideDelayed(delay = DEFAULT_HIDE_DELAY) {
        this.clearTimeouts();
        this.hideTimeout = window.setTimeout(() => {
            this.hide();
        }, delay);
    }
}
export default angular
    .module('doxy.common.services.callQualitySurveyService', [])
    .service('callQualitySurveyService', CallQualitySurveyService).name;
